import { atom } from "jotai";

import {
  VerifyEmailOrPhoneStepStateAtom,
  defaultVerifyEmailOrPhoneStepState,
} from "./stores";
import { VerifyCodeStepState } from "./types";

export const ProceedToVerifyCodeStepAtom = atom(
  null,
  (
    _,
    set,
    {
      email,
      phone,
    }: {
      email: string | null;
      phone: string | null;
    }
  ) => {
    const nextStep: VerifyCodeStepState = {
      step: "VerifyCode",
      email,
      phone,
      backStep: "Initial",
    };
    set(VerifyEmailOrPhoneStepStateAtom, nextStep);
  }
);

export const GoBackToPreviousVerificationStepAtom = atom(null, (get, set) => {
  const state = get(VerifyEmailOrPhoneStepStateAtom);
  const backStep = state.backStep;
  if (backStep) {
    switch (backStep) {
      case "Initial":
        set(
          VerifyEmailOrPhoneStepStateAtom,
          defaultVerifyEmailOrPhoneStepState
        );
        break;
      default:
        set(
          VerifyEmailOrPhoneStepStateAtom,
          defaultVerifyEmailOrPhoneStepState
        );
    }
  }
});
